import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import { changeUserStatus } from 'action/user'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'
import _ from 'lodash'

const getEnabledText = (enabled) => enabled ? 'disable' : 'enable'

const generateModalText = (user, action) => ({
  decide: {
    content: '',
    title: `Are you sure you want to ${action} ${user.first_name} ${user.last_name}?`
  },
  outcome: {
    content: {
      error: 'Please try again.',
      success: `${user.first_name} ${user.last_name} has been successfully ${action}d.`
    },
    title: {
      error: `There has been a issue updating ${user.first_name} ${user.last_name} status`,
      success: `User ${action}d`
    }
  }
})

const ChangeUserStatus = ({ user, changeUserStatus }) => {
  const handleSubmit = () => changeUserStatus(user.uuid)

  const action = getEnabledText(user.enabled)

  const { decide, outcome } = generateModalText(user, action)

  return (
    <a onClick={() => confirmModal(handleSubmit, decide, outcome)}>{`${_.startCase(action)} User`}</a>
  )
}

ChangeUserStatus.propTypes = {
  changeUserStatus: PropTypes.func,
  user: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  changeUserStatus: bindActionCreators(changeUserStatus, dispatch)
})

export default connect(null, mapDispatchToProps)(ChangeUserStatus)
